module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/multisig/index.js
// module id = 1uFs
// module chunks = 0